import { useCallback, useState } from 'react';

export const useRefreshPage = refetch => {

	const [isRefreshing, setIsRefreshing] = useState(false);

	const refreshPage = useCallback(async () => {
		setIsRefreshing(true);
		try {
			await refetch();
		}
		finally {
			setIsRefreshing(false);
		}
	}, [refetch]);

	return [refreshPage, isRefreshing];

};
